import { useGetCentralizedOrganizationLogoQuery } from "./graphql/GetCentralizedOrganizationLogo.v5.generated";
var useOrganizationTheme = function useOrganizationTheme(organizationId) {
  var _data$centralized_org, _data$centralized_org2;
  var _useGetCentralizedOrg = useGetCentralizedOrganizationLogoQuery({
      variables: {
        organizationId: organizationId || 0
      },
      context: {
        clientName: 'v5'
      },
      skip: !organizationId
    }),
    data = _useGetCentralizedOrg.data,
    loading = _useGetCentralizedOrg.loading,
    error = _useGetCentralizedOrg.error;
  return {
    data: (data === null || data === void 0 ? void 0 : (_data$centralized_org = data.centralized_organization) === null || _data$centralized_org === void 0 ? void 0 : (_data$centralized_org2 = _data$centralized_org.personalization) === null || _data$centralized_org2 === void 0 ? void 0 : _data$centralized_org2.logo) || '',
    loading: loading,
    error: error
  };
};
export default useOrganizationTheme;